import React from "react";
import SimpleDatabasePage from "./SimpleDatabasePage";
import LaborDatabasePage from "./LaborDatabasePage";
import ToolsDatabasePage from "./ToolsDatabasePage";
import MaterialsDatabasePage from "./MaterialsDatabasePage";
import CatalogMappingPage from "./CatalogMappingPage";
import { DATABASE_NAV, SIMPLE_PAGES } from "constants/estimatingDatabasePages";

const DEDICATED = {
  materials: MaterialsDatabasePage,
  labor: LaborDatabasePage,
  tools: ToolsDatabasePage,
  "catalog-mapping": CatalogMappingPage,
};

// One route per drawer entry: { path, component }. The page is keyed so a
// switch between two simple pages starts from a clean state.
export const ESTIMATING_DATABASE_ROUTES = DATABASE_NAV.map((entry) => {
  const Dedicated = DEDICATED[entry.key];
  if (Dedicated) return { path: entry.path, component: Dedicated };
  if (!SIMPLE_PAGES[entry.key]) return null;
  const Page = () => <SimpleDatabasePage key={entry.key} pageKey={entry.key} />;
  Page.displayName = `DatabasePage(${entry.key})`;
  return { path: entry.path, component: Page };
}).filter(Boolean);

export {
  SimpleDatabasePage,
  LaborDatabasePage,
  ToolsDatabasePage,
  MaterialsDatabasePage,
  CatalogMappingPage,
};
